import { render } from "./texture.vue?vue&type=template&id=6d05894f&scoped=true"
import script from "./texture.vue?vue&type=script&lang=js"
export * from "./texture.vue?vue&type=script&lang=js"

import "./texture.vue?vue&type=style&index=0&id=6d05894f&lang=scss&scoped=true"
import "./texture.vue?vue&type=style&index=1&id=6d05894f&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d05894f"]])

export default __exports__